export enum WaitingPeriodPopupStateEnum {
	HIDDEN = "hidden",
	MINIMIZED = "minimized",
	ACTIVE = "active",
}
